import React, { useState } from "react";
import Swal from "sweetalert2";
import Navbar from "../../Header/header";
import SuperAdminSidebar from "../../Dashboard/SuperAdmin/Superadmincom/SuperAdminSidebar";

export default function QuestionDetails() {
  const [questions, setQuestions] = useState([]);
  const [questionText, setQuestionText] = useState("");
  const [options, setOptions] = useState(["", "", "", ""]);
  const [correctOption, setCorrectOption] = useState(null);

  // Handle adding a question
  const handleAddQuestion = () => {
    if (!questionText || correctOption === null) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Please fill out the question and select the correct option.",
      });
      return;
    }

    setQuestions([
      ...questions,
      {
        id: questions.length + 1,
        text: questionText,
        options,
        correctOption,
      },
    ]);

    setQuestionText("");
    setOptions(["", "", "", ""]);
    setCorrectOption(null);
  };

  // Handle changing an option
  const handleOptionChange = (index, value) => {
    const updatedOptions = [...options];
    updatedOptions[index] = value;
    setOptions(updatedOptions);
  };

  return (
    <div className="container-scroller">
          <Navbar />
          <div className="container-fluid page-body-wrapper">
            <SuperAdminSidebar />
            <div className="main-panel">
              <div className="content-wrapper">
    <div className="container mt-4">
      <div className="card p-4 mb-4">
        <h2 className="mb-4">Add Question</h2>

        <div className="mb-3">
          <label htmlFor="questionText" className="form-label">
            Question
          </label>
          <input
            type="text"
            id="questionText"
            className="form-control"
            placeholder="Enter your question"
            value={questionText}
            onChange={(e) => setQuestionText(e.target.value)}
          />
        </div>

        <div className="mb-3">
          <label className="form-label">Options</label>
          {options.map((option, index) => (
            <div key={index} className="input-group mb-2">
              <input
                type="text"
                className="form-control"
                placeholder={`Option ${index + 1}`}
                value={option}
                onChange={(e) => handleOptionChange(index, e.target.value)}
              />
              <div className="input-group-text">
                <input
                  type="radio"
                  name="correctOption"
                  value={index}
                  onChange={() => setCorrectOption(index)}
                  checked={correctOption === index}
                />
              </div>
            </div>
          ))}
        </div>

        <button
          className="btn btn-primary"
          onClick={handleAddQuestion}
        >
          Add Question
        </button>
      </div>

      <div className="card p-4">
        <h2 className="mb-4">Questions</h2>
        <div className="row">
          {questions.map((question) => (
            <div className="col-md-6 col-lg-4 mb-4" key={question.id}>
              <div
                className="card p-3 shadow-sm"
                style={{ cursor: "pointer" }}
                onMouseEnter={(e) => {
                  const optionsDiv = e.currentTarget.querySelector(".options");
                  optionsDiv.style.display = "block";
                }}
                onMouseLeave={(e) => {
                  const optionsDiv = e.currentTarget.querySelector(".options");
                  optionsDiv.style.display = "none";
                }}
              >
                <h5>{question.text}</h5>
                <div
                  className="options mt-3"
                  style={{ display: "none" }}
                >
                  {question.options.map((option, index) => (
                    <p
                      key={index}
                      style={{
                        color:
                          question.correctOption === index ? "green" : "black",
                        fontWeight:
                          question.correctOption === index ? "bold" : "normal",
                      }}
                    >
                      {option}
                    </p>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
    </div>
    </div>
    </div>
    </div>
  );
}